import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import tw from "twin.macro";

import PostList from "./post-list";

import AppLink from "../app-link";
import Hero from "../hero";
import Tabs from "../tabs";

const PageContainer = tw.div`lg:space-x-8 my-8 container mx-4 sm:mx-auto flex flex-col lg:flex-row justify-between w-auto `;
const Sidebar = tw.aside`lg:w-64 mt-8 px-4 lg:px-0`;
const SidebarHeading = tw.h3`text-red-900 pl-2 -ml-4 border-l-8 border-red-900 font-bold uppercase`;
const SidebarSection = tw.div`mb-8`;
const Pagination = tw.div`space-x-4`;

const NewsContent = ({ pageData, numPages, currentPage }) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "news-banner.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const tabs = [
    { label: "News", active: true, to: "/updates" },
    { label: "Newsletters", active: false, to: "/updates/newsletters" },
    { label: "Meetings and Events", active: false, to: "/updates/events" },
    {
      label: "Funding Opportunities",
      active: false,
      to: "/updates/funding-opportunities"
    }
  ];
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === numPages;
  return (
    <>
      <Hero imgQuery={data.file.childImageSharp.fluid}>News</Hero>
      <div tw="bg-gray-100">
        <div tw="container mx-4 sm:mx-auto">
          <Tabs tabs={tabs} />
        </div>
      </div>
      <PageContainer>
        <div tw="flex-1">
          <PostList pageData={pageData} />
          <Pagination>
          {!isFirstPage && <AppLink to={currentPage == 2 ? '/updates' : `/updates/${currentPage-1}`}>&#171; New Posts</AppLink>}
          {!isLastPage && <AppLink to={`/updates/${currentPage+1}`}>Older Posts &#187;</AppLink>}
          </Pagination>
        </div>
        <Sidebar>
          <SidebarSection>
            <SidebarHeading>Looking for Something Else?</SidebarHeading>
            <ul>
            <li><AppLink to="/updates/newsletters">CP-CTNet Newsletters</AppLink></li>
            <li><AppLink to="/updates/events">Steering Committee memos</AppLink></li>
            </ul>
          </SidebarSection>
        </Sidebar>
      </PageContainer>
    </>
  );
};

NewsContent.propTypes = {
  pageData: PropTypes.object,
  numPages: PropTypes.number,
  currentPage: PropTypes.number
};

export default NewsContent;
